var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307 543 c-13 -12 -7 -61 7 -66 20 -8 26 2 26 40 0 31 -16 44 -33 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 515 c9 -11 26 -38 37 -60 12 -22 21 -36 22 -32 0 15 -39 84 -57 97 -17 14 -17 14 -2 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 514 c-8 -9 21 -64 34 -64 16 0 21 27 9 49 -10 21 -30 27 -43 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 434 c-7 -19 23 -46 46 -42 27 5 22 27 -9 43 -28 14 -31 14 -37 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 421 c-35 -22 -63 -67 -63 -103 0 -36 36 -87 75 -105 28 -14 43 -15 74 -7 24 7 45 7 59 1 34 -15 88 1 116 34 47 56 46 106 -3 161 -29 32 -48 36 -131 28 -8 0 -33 2 -55 5 -30 5 -48 1 -72 -14z m177 -99 l0 -99 -82 12 c-90 13 -118 33 -118 85 0 51 29 72 116 85 43 7 80 13 82 14 1 0 2 -43 2 -97z m57 56 c32 -30 31 -87 -1 -117 -14 -13 -29 -20 -35 -16 -12 7 -15 137 -4 148 10 11 15 9 40 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 365 c-15 -33 -15 -57 0 -90 18 -40 23 -30 23 40 -1 73 -7 86 -23 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 330 c-11 -17 5 -30 36 -30 22 0 29 5 29 20 0 15 -7 20 -29 20 -17 0 -33 -4 -36 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 237 c-12 -9 -17 -20 -13 -31 6 -15 9 -15 37 -1 31 16 36 38 9 43 -8 1 -23 -4 -33 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 160 c-14 -28 -14 -31 1 -37 19 -7 46 23 42 46 -5 27 -27 22 -43 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 161 c-18 -12 -10 -65 12 -69 13 -3 17 4 17 32 0 38 -9 49 -29 37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.059a1c5f7bef0f6bc008f36e718692f0.svg";
export { ForwardRef as ReactComponent };